import ajax from '../http/ajax'

export const getClassification = _ => {
    return ajax.get('getClassification')
}
